import { useMutation } from '@tanstack/react-query';
import { makeRemotePostAuditBsDismiss } from 'main/factories/usecases';
import { FIVE_SECONDS, showToast, TEN_SECONDS, TOAST_ERROR, TOAST_SUCCESS } from 'lib/utils';
import { DismissBalanceSheetAuditRequest } from '@hone-automation/common';

export const useDismissBalanceSheetAudit = () => {
  return useMutation({
    mutationFn: (params: DismissBalanceSheetAuditRequest) => {
      const dismissAuditService = makeRemotePostAuditBsDismiss();
      return dismissAuditService.dismiss(params);
    },
    onError: e => {
      showToast(e.message, TOAST_ERROR, TEN_SECONDS);
    },
    onSuccess: () => {
      showToast('Audit dismissed successfully', TOAST_SUCCESS, FIVE_SECONDS);
    },
  });
};
